module.exports = __webpack_public_path__ + "static/media/沃店+.d6b5d0a3.png";